import React from 'react';
import './header.css';
import { NavLink as Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from '../../store/auth/actions';
import { menuToggle, toggleClientMenu, selectClient } from '../../store/system/actions';
import { SystemState } from '../../store/system/types';
import { AppState } from '../../store';
import { filterClients } from '../../store/clients/actions';
import { ClientsState } from '../../store/clients/types';
import { ReactComponent as AccountIcon } from '../../icons/account.svg';

interface AppHeaderInterface {
    clients: ClientsState
    system: SystemState
    logout: typeof logout
    menuToggle: typeof menuToggle
    toggleClientMenu: typeof toggleClientMenu
    selectClient: typeof selectClient
    filterClients: typeof filterClients
}

const mapDispatchToProps = dispatch => {
    return {
      logout: () => dispatch(logout() ),
      menuToggle: () => dispatch(menuToggle() ),
      toggleClientMenu: () => dispatch(toggleClientMenu() ),
      selectClient: (client, history) => dispatch(selectClient(client, history) ),
      filterClients: e => dispatch(filterClients(e.target.value) )
    }
}

const mapStateToProps = (state: AppState) => ({
    system: state.system,
    clients: state.clients
})

class AppHeader extends React.Component<AppHeaderInterface & RouteComponentProps> {
    componentDidMount() {

    }

    toggleClientMenu() {
        this.props.toggleClientMenu();
        this.props.filterClients({target: {value: ''}});
    }

    render() {
        var selectedClient = this.props.system.selectedClient;
        var clientName = selectedClient !== null ? selectedClient.clientName : '';
        var isExpanded = this.props.system.clientsExpanded;
        var isAdmin = this.props.system.isAdmin;

        return (
            <div className="app__header">
                {isAdmin ? (
                    <div className="header__client-info">
                        <button
                            onClick={this.toggleClientMenu.bind(this)}
                            className="header__client-btn"
                        >
                            <AccountIcon height="14" />
                            <span className="header__client-name">{clientName}</span>
                            <span className={isExpanded ? 'header__chevron expanded' : 'header__chevron'}>&lsaquo;</span>
                        </button>

                        {isExpanded ? (
                            <>
                                <div
                                    className="header__client-backdrop"
                                    onClick={this.toggleClientMenu.bind(this)}
                                />
                                <div className="header__client-dropdown">
                                    <div className="header__client-search">
                                        <input
                                            type="text"
                                            onChange={this.props.filterClients}
                                            placeholder="Search clients..."
                                        />
                                    </div>
                                    <ul>
                                        {this.props.clients.clientsFiltered.map(client =>
                                            <li
                                                onClick={() => this.props.selectClient(client, this.props)}
                                                key={`acc_${client.id}`}
                                            >
                                                {client.clientName}
                                                <span className="header__client-email">{client.clientEmail}</span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </>
                        ) : null}
                    </div>
                ) : null}
                <button className="sign__out" onClick={() => this.props.logout()}>Sign Out</button>
            </div>
        )
    }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppHeader));
